/*
  Termen scurt: bifa obligatorie din coș (snippets/tuju-termen-scurt.liquid, mode 'accept'), în coșul lateral și pe /cart.

  - Bifa se salvează prin /cart/update.js în două atribute de coș: data-attr („Termen scurt acceptat”) = data-yes („Da”)
    și data-attr-for („Termen scurt acceptat pentru”) = data-sig, amprenta produselor „Termen scurt” din coș. Alt produs
    cu tag în coș = altă amprentă: Liquid nu mai pune bifa, iar alegerea din pagină nu se aplică amprentei noi.
  - Până la bifare, „Finalizează comanda” e dezactivat (disabled); plata rapidă din /cart rămâne inertă până când
    serverul confirmă salvarea. Salvările merg pe rând; una eșuată readuce bifa la debifat, cu mesaj. Se reactivează doar
    butoanele dezactivate de aici (data-tuju-ts-lock), nu și cele oprite de temă.
  - Tema re-randează doar unele zone: în coșul lateral lista din subsol (unde stă bifa), nu și butonul; pe /cart toată
    secțiunea. Un MutationObserver pe cele două secțiuni reface starea după fiecare re-randare (răspunsul temei poate
    veni din cache, cu bifa veche).
  - La „Finalizează comanda” se cere secțiunea coșului proaspătă (no-store). Amprenta reală diferită de cea din formular
    (sertar vechi, alt tab, pagină din cache) → se deschide /cart cu starea reală, nu plata. Fără răspuns în 6 s decide
    formularul din pagină. Coș fără produse cu tag, dar cu atributele unei bifări vechi → se golesc la plată.
  - /cart revenit din cache-ul de navigare (Înapoi) sau din alt tab: aceeași verificare, ca plata rapidă să nu pornească
    pe un coș vechi.
*/
(function () {
  if (window.__tujuTs) return;
  window.__tujuTs = true;
  document.documentElement.classList.add('tuju-ts-js');

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BOX = '[data-tuju-ts-accept]';
  var FORMS = '.quick-cart__form, .cart__form';
  var EXPRESS = '.additional-checkout-buttons';
  var WAIT_MS = 6000;
  var choice = null; // alegerea din pagină (true / false) pentru amprenta choiceSig; null = starea venită din server
  var choiceSig = '';
  var saved = true; // serverul a confirmat ultima alegere (plata rapidă o așteaptă)
  var failed = false;
  var seq = 0;
  var queue = Promise.resolve();
  var clicked = null; // ultimul buton de trimitere apăsat, pentru browserele fără e.submitter

  function cartUrl() {
    return (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.base) || root + 'cart';
  }
  function boxOf(node) { return node ? node.querySelector(BOX) : null; }
  function inputOf(box) { return box ? box.querySelector('input[type="checkbox"]') : null; }
  function sigOf(box) { return box ? box.getAttribute('data-sig') || '' : ''; }

  function lock(form, on, express) {
    var hint = form.querySelector(BOX + ' .tuju-ts-accept__hint[id]');
    form.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (on) {
        b.disabled = true;
        b.setAttribute('data-tuju-ts-lock', '');
        if (hint) b.setAttribute('aria-describedby', hint.id);
      } else if (b.hasAttribute('data-tuju-ts-lock')) {
        b.disabled = false;
        b.removeAttribute('data-tuju-ts-lock');
        b.removeAttribute('aria-describedby');
      }
    });
    form.querySelectorAll(EXPRESS).forEach(function (el) {
      if (express) el.setAttribute('inert', '');
      else el.removeAttribute('inert');
    });
  }

  function sync() {
    document.querySelectorAll(FORMS).forEach(function (form) {
      var box = boxOf(form);
      var input = inputOf(box);
      if (input && choice !== null && sigOf(box) === choiceSig) input.checked = choice;
      var err = box && box.querySelector('[data-tuju-ts-err]');
      if (err) err.hidden = !failed;
      lock(form, !!input && !input.checked, !!input && (!input.checked || !saved));
    });
  }

  function send(attrs, key, id) {
    if (id !== seq) return null; // a venit între timp altă alegere: trimitem doar ultima
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/update ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        var a = (cart && cart.attributes) || {};
        if ((a[key] || '') !== attrs[key]) throw new Error('atributul nu s-a salvat');
        if (id !== seq) return;
        saved = true;
        sync();
      })
      .catch(function () {
        if (id !== seq) return;
        // Nesalvat: starea sigură e debifat (plata rămâne blocată), cu mesaj.
        choice = false;
        saved = true;
        failed = true;
        sync();
      });
  }

  function save(box, on) {
    var id = ++seq;
    var key = box.getAttribute('data-attr');
    var attrs = {};
    attrs[key] = on ? box.getAttribute('data-yes') : '';
    attrs[box.getAttribute('data-attr-for')] = on ? sigOf(box) : '';
    saved = false;
    sync();
    queue = queue.then(function () { return send(attrs, key, id); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    var box = input && input.closest && input.closest(BOX);
    if (!box || input.type !== 'checkbox') return;
    choice = input.checked;
    choiceSig = sigOf(box);
    failed = false;
    save(box, choice);
  });

  // ---- verificarea coșului real ----
  function fresh(form) {
    var sec = form.closest('[id^="shopify-section-"]');
    if (!sec || !window.DOMParser) return Promise.reject(new Error('fără secțiune'));
    var url = cartUrl() + '?section_id=' + encodeURIComponent(sec.id.replace('shopify-section-', ''));
    var req = fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('section ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return { sig: sigOf(boxOf(doc)), clear: doc.querySelector('[data-tuju-ts-clear]') };
      });
    var late = new Promise(function (resolve, reject) {
      setTimeout(function () { reject(new Error('timeout')); }, WAIT_MS);
    });
    return Promise.race([req, late]);
  }

  function reloadCart() {
    window.location.assign(cartUrl() + '?tuju_ts=' + Date.now());
  }

  function refuse(input) {
    sync();
    var box = input.closest(BOX);
    if (box && box.scrollIntoView) box.scrollIntoView({ block: 'nearest' });
    try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
  }

  function go(form, sub, clear) {
    if (!form.isConnected) return; // formularul a fost re-randat între timp: e nevoie de un clic nou
    if (clear) {
      [clear.getAttribute('data-attr'), clear.getAttribute('data-attr-for')].forEach(function (k) {
        if (!k) return;
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = 'attributes[' + k + ']';
        h.value = '';
        form.appendChild(h);
      });
    }
    form.__tujuTsPass = true;
    if (form.requestSubmit && sub.form === form) {
      try {
        form.requestSubmit(sub);
        return;
      } catch (err) { /* trimiterea clasică, mai jos */ }
    }
    form.__tujuTsPass = false;
    var b = document.createElement('input');
    b.type = 'hidden';
    b.name = sub.name;
    b.value = sub.value || '';
    form.appendChild(b);
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
    clicked = b && b.form && b.type === 'submit' ? b : null;
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORMS)) return;
    var sub = e.submitter || (clicked && clicked.form === form ? clicked : null);
    clicked = null;
    // În coșul lateral singurul buton de trimitere e „Finalizează comanda” (și Enter în câmpul de cantitate).
    if (!sub && form.matches('.quick-cart__form')) sub = form.querySelector('button[name="checkout"]');
    if (!sub || sub.name !== 'checkout') return;
    if (form.__tujuTsPass) {
      form.__tujuTsPass = false;
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.__tujuTsBusy) return;
    var input = inputOf(boxOf(form));
    if (input && !input.checked) return refuse(input);

    form.__tujuTsBusy = true;
    sub.setAttribute('aria-busy', 'true');
    function done() {
      form.__tujuTsBusy = false;
      sub.removeAttribute('aria-busy');
    }
    fresh(form)
      .then(function (f) {
        var box = boxOf(form);
        if (f.sig !== sigOf(box)) return reloadCart();
        var now = inputOf(box);
        if (now && !now.checked) return refuse(now);
        go(form, sub, f.sig === '' ? f.clear : null);
      }, function () {
        // Fără răspuns: decide formularul din pagină (bifa a fost verificată mai sus).
        var now = inputOf(boxOf(form));
        if (now && !now.checked) return refuse(now);
        go(form, sub, null);
      })
      .then(done, done);
  }, true);

  function recheck() {
    var form = document.querySelector('.cart__form');
    if (!form || !form.querySelector(EXPRESS)) return;
    fresh(form).then(function (f) {
      if (f.sig !== sigOf(boxOf(form))) reloadCart();
    }, function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) recheck(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') recheck();
  });

  // ---- re-randările temei ----
  var mo = window.MutationObserver ? new MutationObserver(sync) : null;
  function watch() {
    if (!mo) return;
    document.querySelectorAll('[data-section-type="quick-cart"], [data-section-type="cart"]').forEach(function (el) {
      mo.observe(el, { childList: true, subtree: true });
    });
  }
  watch();
  sync();
  // Editorul de temă re-randează secțiunile fără reîncărcarea paginii.
  document.addEventListener('shopify:section:load', function () { watch(); sync(); });
})();
